import { Button } from '../../../components/button';
import { Stack } from '../../../components/stack';
import { Typography } from '../../../components/typography';
import { useFenrirTranslation } from '../../../locales/use-fenrir-translation';
import { SadWolf } from '../../../svgs/sad-wolf';

/** @deprecated Use ErrorServer instead. This will be removed in the next version. */
export const ErrorSadWolf = () => {
  const { t } = useFenrirTranslation({ keyPrefix: 'errors.sadWolf' });

  return (
    <Stack
      direction="column"
      spacing={2}
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <SadWolf />
      <Typography variant="h1" color="textSecondary">
        {t('oops')}
      </Typography>
      <Typography
        color="textSecondary"
        sx={{
          whiteSpace: 'pre-line',
          textAlign: 'center',
        }}
      >
        {t('unexpectedError')}
      </Typography>
      <Button
        color="primary"
        variant="contained"
        onClick={() => window.location.reload()}
      >
        {t('refresh')}
      </Button>
    </Stack>
  );
};
